import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import Headline from 'components/Headline/styles';
import {DashboardContent} from 'components/DashboardContent/styles';
import {DashboardHeader} from 'components/DashboardHeader/styles';
import RCHeader from 'routes/App/Managers/RefundsCalculator/Components/RCHeader';
import RCSearch from 'routes/App/Managers/RefundsCalculator/Components/RCSearch';
import RCOptions from 'routes/App/Managers/RefundsCalculator/Components/RCOptions';
import RCOperations from 'routes/App/Managers/RefundsCalculator/Components/RCOperations';
import AdditionInformationModal from 'routes/App/Managers/RefundsCalculator/Components/Modals/AdditionInformationModal';
import {RefundsCalculatorContainer} from 'routes/App/Managers/RefundsCalculator/styles';
import RCResult from 'routes/App/Managers/RefundsCalculator/Components/RCResult';
import RequestResultModal from 'routes/App/Managers/RefundsCalculator/Components/Modals/RequestResultModal';
import {RC_CLEAR_ALL_CALCULATOR_DATA} from 'store/refundsCalculator/action';
import RCReimbursementResult from 'routes/App/Managers/RefundsCalculator/Components/RCReimbursementResult';
import RequestReimbursementResultModal from 'routes/App/Managers/RefundsCalculator/Components/Modals/RequestReimbursementResultModal';

const RefundsCalculator = () => {
  const [openAdditionInfoModal, setOpenAdditionInfoModal] = useState(false);
  const {
    orderData,
    refunds,
    resultModal,
    resultModalInfo,
    merchant,
    resultModalReinbersment,
    reimbursements
  } = useSelector((state) => state.refundsCalculator);

  const dispatch = useDispatch();

  useEffect(() => {
    return () => dispatch(RC_CLEAR_ALL_CALCULATOR_DATA());
  }, []);

  return (
    <RefundsCalculatorContainer>
      <DashboardContent className='DashboardContent overflowInherit DashboardContentWithoutHeader BgGrey'>
        <DashboardHeader>
          <Headline>Refunds Calculator</Headline>
        </DashboardHeader>
        <RCSearch />
        {!!orderData?.id && (
          <>
            <RCHeader
              orderData={orderData}
              setOpenAdditionInfoModal={setOpenAdditionInfoModal}
              refunds={refunds}
              reimbursements={reimbursements}
            />
            {refunds.length > 0 && <RCResult />}
            {reimbursements.length > 0 && <RCReimbursementResult />}
            {!reimbursements.length > 0 && !refunds.length > 0 && (
              <RCOperations />
            )}
          </>
        )}
      </DashboardContent>
      <AdditionInformationModal
        orderData={orderData}
        openAdditionInfoModal={openAdditionInfoModal}
        setOpenAdditionInfoModal={setOpenAdditionInfoModal}
        merchant={merchant}
      />
      <RequestResultModal openModal={resultModal} info={resultModalInfo} />
      <RequestReimbursementResultModal
        openModal={resultModalReinbersment}
        info={resultModalInfo}
      />
    </RefundsCalculatorContainer>
  );
};

export default RefundsCalculator;
